import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ darkMode, toggleDarkMode }) => {
  const location = useLocation();

  const isPreventivi = location.pathname.startsWith('/preventivi') || location.pathname === '/';

  return (
    <div className="w-64 h-screen bg-white dark:bg-black border-r border-gray-100 dark:border-gray-800 flex flex-col fixed left-0 top-0 transition-colors duration-300 z-30">
      {/* Logo */}
      <div className="p-8 pb-4">
         <img 
           src={darkMode ? "/images/logo_bianco.png" : "/images/logo_nero.png"} 
           alt="AiYR4" 
           className="h-8 w-auto mb-2" 
         />
         <div className="text-[10px] tracking-[0.3em] font-medium text-gray-500 uppercase">
           Private Office
         </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 overflow-y-auto px-4 space-y-1">
        <Link
          to="/preventivi"
          className={`
            flex items-center px-4 py-3 text-sm rounded-lg transition-all duration-200 group
            ${isPreventivi && !location.pathname.includes('/nuovo') && !location.pathname.includes('/edit')
              ? 'bg-black text-white dark:bg-white dark:text-black font-medium shadow-md' 
              : 'text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-900'}
          `}
        >
          <svg 
            className={`w-5 h-5 mr-3 ${isPreventivi && !location.pathname.includes('/nuovo') && !location.pathname.includes('/edit') ? 'text-white dark:text-black' : 'text-gray-400 group-hover:text-black dark:group-hover:text-white'}`}
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor" 
            strokeWidth={1.5}
          >
            <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Preventivi
        </Link>
        
        {/* Nuovo Preventivo */}
        <Link 
          to="/preventivi/nuovo"
          className="mt-4 flex items-center justify-center px-4 py-3 mx-2 text-xs font-medium tracking-wider uppercase border border-dashed border-gray-300 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:border-black dark:hover:border-white hover:text-black dark:hover:text-white transition-all rounded-lg"
        >
          + Nuovo Preventivo
        </Link>
      </nav>

      {/* User / Bottom Section */}
      <div className="p-4 border-t border-gray-100 dark:border-gray-800">
        <div className="flex items-center gap-3 px-2">
          <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-xs font-bold text-gray-500">
            L
          </div>
          <div className="flex-1 overflow-hidden">
            <div className="text-sm font-medium truncate dark:text-white">Leonardo Pi...</div>
            <div className="text-[10px] text-gray-400 truncate">leonardo.picollo2004...</div>
          </div>
          <button onClick={toggleDarkMode} className="text-gray-400 hover:text-black dark:hover:text-white transition-colors">
            {darkMode ? (
               <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
               </svg>
            ) : (
               <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
               </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
